export default "__VITE_ASSET__DzxKGhQe__"